export default __webpack_public_path__ + "static/heroSectionBg-446dcc17467f91c680a5d7ad944e1b23.png";